import { FetchRequest, WebSocketTransport } from 'ably/modular';
import Push from 'ably/push';
import { Realtime } from 'ably';
import Objects from 'ably/objects';
import isLocalStorageAvailable from '@/helpers/isLocalStorageAvailable.js';

const createClientId = () => {
    const randomPart = Math.random().toString(36).substring(2, 5).toUpperCase();
    return `client-${randomPart}-${Date.now()}`;
};

const THREE_HOURS = 3 * 60 * 60 * 1000;
let clientId = createClientId();

if (isLocalStorageAvailable()) {
    const stored = localStorage.getItem('ablyClientId');
    const parts = stored?.split('-');
    const timestamp = parts?.[2];
    const isExpired =
        !timestamp || Date.now() - Number(timestamp) > THREE_HOURS;

    clientId = isExpired ? createClientId() : stored;
    localStorage.setItem('ablyClientId', clientId);
}

const ably = new Realtime({
    key: import.meta.env.VITE_ABLY_API_KEY,
    pushServiceWorkerUrl: '/ably-push-service-worker.js',
    clientId,
    plugins: {
        FetchRequest,
        WebSocketTransport,
        Push,
        Objects
    }
});

export default ably;
